import { render, staticRenderFns } from "./Stores.vue?vue&type=template&id=4003f713&scoped=true&"
import script from "./Stores.vue?vue&type=script&lang=js&"
export * from "./Stores.vue?vue&type=script&lang=js&"
import style0 from "./Stores.vue?vue&type=style&index=0&id=4003f713&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4003f713",
  null
  
)

export default component.exports